export const UPDATE_VOTE_DATA = "UPDATE_VOTE_DATA";



// WEBPACK FOOTER //
// ./src/services/votedata/constants.js